import { createTRPCReact } from "@trpc/react-query";
import type { AppRouter } from "@iterate/server/handlers";

export const trpc = createTRPCReact<AppRouter>();
